import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Forms',
  },
  {
    path: 'Inputs',
    breadcrumbName: 'Inputs',
  },
];

const Inputs = () => {
  return (
    <>


      <PageHeader title="Inputs" breadcrumb={{ routes }} subTitle="Input" style={{ padding: 10 }} />

      <div className="MF_area">
        <input type="text" className="input_text input_sm" placeholder="input_sm" />
        <br /><br />
        <input type="text" className="input_text input_md" placeholder="input_md" />
        <br /><br />
        <input type="text" className="input_text input_lg" placeholder="input_lg" />
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<input type="text" class="input_text input_sm" placeholder="input_sm">
<div class="clearfix"></div>
<input type="text" class="input_text input_md" placeholder="input_md">
<div class="clearfix"></div>
<input type="text" class="input_text input_lg" placeholder="input_lg">`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>




      <PageHeader title="Inputs" breadcrumb={{ routes }} subTitle="input_Append" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="input_group">
          <input type="text" className="input_text" placeholder="input_group_append" />
          <div className="input_group_append">
            <span className="input_group_text">아이디를 입력하세요.</span>
          </div>
        </div>
      </div>

      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="input_group">
  <input type="text" class="input_text" placeholder="input_group_append" />
  <div class="input_group_append">
    <span class="input_group_text">아이디를 입력하세요.</span>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>




      <PageHeader title="Inputs" breadcrumb={{ routes }} subTitle="input_prepend" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="input_group">
          <div className="input_group_prepend">
            <span className="input_group_text">비밀번호 입력란</span>
          </div>
          <input type="text" className="input_text" placeholder="input_group_prepend" />
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="input_group">
<div class="input_group_prepend">
<span class="input_group_text">비밀번호 입력란</span>
</div>
<input type="text" class="input_text" placeholder="input_group_prepend" />
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>




      <PageHeader title="Inputs" breadcrumb={{ routes }} subTitle="input_prepend & input_Append" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="input_group">
          <div className="input_group_prepend">
            <span className="input_group_text">비밀번호 입력란</span>
          </div>
          <input type="text" className="input_text" placeholder="input_group_prepend & input_group_append" />
          <div className="input_group_append">
            <span className="input_group_text">비밀번호를 입력하세요.</span>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="input_group">
  <div class="input_group_prepend">
    <span class="input_group_text">비밀번호 입력란</span>
  </div>
  <input type="text" class="input_text" placeholder="input_group_prepend & input_group_append">
  <div class="input_group_append">
    <span class="input_group_text">비밀번호를 입력하세요.</span>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default Inputs;
